export default __webpack_public_path__ + "static/media/CADScreen.fc2c3a20.png";